export enum ACCESS_TOGGLE_MODE {
    inherit = 'inherit',
    off = 'off',
    on = 'on',
}
